import { HsVector3 } from '../../math-new/objects/vector3.class';
import type { HsGraphicObject } from './graphic-object.class';

export class HsRaycastOutput {
  public id: number = 0;
  public type: number = 0;
  public object: HsGraphicObject | null = null;
  public instanceIndex: number | null = null;
  public readonly position: HsVector3 = HsVector3.makeZeroVector();
}
